const months = [
  "január",
  "február",
  "március",
  "április",
  "május",
  "június",
  "július",
  "augusztus",
  "szeptember",
  "október",
  "november",
  "december",
]

export const formatMonth = (date) => {
  const parts = date.split("-")
  const year = parts[0]
  const monthIndex = parseInt(parts[1], 10) - 1
  const month = months[monthIndex]
  const day = parseInt(parts[2], 10)

  return `${year}. ${month} ${day}.`
}

export const articleDateFormatter = (dateString) => {
  const date = new Date(dateString)
  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString().padStart(2, "0")
  const day = date.getDate().toString().padStart(2, "0")
  return `${year}.${month}.${day}.`
}
